import { render } from "./PerformanceReport.vue?vue&type=template&id=b650fb9e&ts=true"
import script from "./PerformanceReport.vue?vue&type=script&lang=ts"
export * from "./PerformanceReport.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/myittar_pharmacy_pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__